export const Svg = ({ id, width = 24, height = 24, size, ...rest }) => (
  <svg width={size || width} height={size || height} {...rest}>
    <use xlinkHref={`/sprite.svg#${id}`} />
  </svg>
);
